<template>
  <b-modal
    ref="logoImgModal"
    hide-footer
    centered
    title="Dashboard logo source"
    size="sm"
    >
    <b-form @submit.prevent="save">
      <b-form-group
        label="Source:"
        >
        <b-form-textarea
          v-model.trim="source"
          @keydown.ctrl.83.native.prevent="save"
          rows="3"
          max-rows="6"
        />
      </b-form-group>
      <b-button
        variant="success"
        type="submit"
        >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';
// source
import db from '@/services/db'

let $ = window.$

export default {
  props: ['eventBus'],
  data () {
    return {
      source: null
    }
  },
  computed: {
    ...mapState([
      'currentDash',
      'settings'
    ])
  },
  methods: {
    save () {
      db.settings.saveLogoImgSource(this.currentDash, this.source)
      if (this.$refs.logoImgModal) this.$refs.logoImgModal.hide()
    }
  },
  created () {
    this.eventBus.$on('showLogoImgModal', () => {
      if (this.$refs.logoImgModal) this.$refs.logoImgModal.show()
    })

    if (this.settings) {
      this.source = this.settings.logoImgSource
    }
  },
  mounted () {
    if (this.$refs.logoImgModal) {
      $(this.$refs.logoImgModal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    if (this.$refs.logoImgModal) {
      $(this.$refs.logoImgModal['$el']).remove()
    }
  }
}
</script>
